import React, { createContext, useEffect, useState } from "react";
import DashboardApis from "Pages/Dashboard/DashboardApis";

export const HomeContext = createContext<any>({});

type HomeContextProviderProps = {
  children: React.ReactNode
}

const HomeContextProvider = ({ children }: HomeContextProviderProps) => {

  const [productName, setProductName] = useState('Viral Patel');
  const [userData, setUserData] = useState<any>({});
  const [matches, setMatches] = useState<any>(false);
  const [userMenuonlineData, setUserMenuonlineData] = useState<any>({});
  const [openCateModal, setOpenCateModal] = useState<any>();
  const [selectedOption, setSelectedOption] = useState({ isOpen: false, type: 'Saved Template'})
  const [homeSearch, setHomeSearch] = useState<any>("");
  const [planData, setPlanData] = useState<any>(null);
  const [upgradeModalOpen, setUpgradeModalOpen] = useState<boolean>(false);

  useEffect(() => {
    if (localStorage.getItem("userData")) {
      const data = JSON.parse(localStorage.getItem("userData") || '{}')
      setUserData(data)
      // if (!window.location.pathname?.includes('/magic/view') && !window.location.pathname?.includes('/ai-magic-create')) {
      //   voidChequeSalesApi(data?.mycircleClientId)
      //   if (data?.mycircleClientId)
      //     getCustomerCreditDetails(data?.mycircleClientId)
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("userData")])

  useEffect(() => {
    const getPlanStatus = async () => {
      const output = await DashboardApis.getPlanStatus(userData?._id)
      if (output?.status && output?.data) {
        setPlanData(output?.data)
      }
    }
    if (userData?._id) {
      getPlanStatus()
    }
  }, [userData?._id])

  return (
    <HomeContext.Provider value={{
      productName, setProductName,
      userMenuonlineData, setUserMenuonlineData,
      openCateModal, setOpenCateModal,
      homeSearch, setHomeSearch,
      selectedOption, setSelectedOption,
      planData, setPlanData,
      upgradeModalOpen, setUpgradeModalOpen,
      userData, setUserData, setMatches, matches
    }}>
      {children}
    </HomeContext.Provider>
  )
}

export default HomeContextProvider;
